import { SectionHeading } from "@/components/SectionHeading";
import { BlogCard } from "@/components/BlogPreview";
import Footer from "@/components/Footer";
import { useContent } from "@/hooks/useContent";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function BlogPage() {
  usePageMeta("Blog", "Histórias, memórias e conhecimento sobre Freestyle, Charme, Funk e Hip-Hop — Blog da Clássicos do Funk.");
  const { data: posts, loading } = useContent("/content/posts/index.json", []);

  return (
    <>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 sm:pt-40 pb-20 sm:pb-28 min-h-screen">
        <SectionHeading
          chapter="Arquivo // Blog da Clássicos"
          title="Todos os posts"
          note="Conteúdo em Markdown, direto do repositório — sem CMS, sem banco."
        />
        {loading && <p className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-500">Carregando posts...</p>}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {posts.map((p, i) => (
            <BlogCard key={p.slug} post={p} index={i} />
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
}
